import React from 'react';

import './chip.scss';

interface ChipProps {
  children: React.ReactNode;
  className?: string;
}

function Chip(props: ChipProps) {
  const { children, className = '' } = props;

  return (
    <span className={`chip ${className}`} styleName="container">
      {children}
    </span>
  );
}

export default Chip;
